import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';

/** Pure Entri eligibility read — no modal, no manufacture, no flow-BI. */

export const resolveEntriEligibility = async _ref => {
  var _await$fetchWithFallb;
  let {
    domain,
    disablePointing,
    enabledBySpec
  } = _ref;
  const {
    httpClient
  } = getPremiumEssentials();
  const {
    entriConfig,
    experiments
  } = DomainsApiClient.queries({
    httpClient: httpClient
  });
  const entriConfigResponse = await entriConfig({
    disablePointing,
    domain
  });
  const {
    checkDomainData,
    config,
    isEligible
  } = entriConfigResponse;
  const isSpecEnabled = enabledBySpec && isEligible ? (_await$fetchWithFallb = (await fetchWithFallback(experiments({
    experiments: [enabledBySpec]
  }), {})).experiments) == null ? void 0 : _await$fetchWithFallb[enabledBySpec] : true;
  return {
    isEligible: !!isEligible,
    isSpecEnabled: !!isSpecEnabled,
    config,
    checkDomainData,
    entriConfigResponse
  };
};
//# sourceMappingURL=resolveEntriEligibility.js.map